import React, {Fragment, useRef} from 'react';
import styled from 'styled-components';
import useScrollButtonsStatus from "../hooks/useScrollButtonsStatus";
import ScrollButtons from "./ScrollButtons";
import RenderOnTablet from "./responsive/RenderOnTablet";
import themeResponsiveProperty from './responsive/themeResponsiveProperty';

export default ({ children, ...props }) => {
  const listRef = useRef(null);
  const [leftEnabled, rightEnabled, scroll] = useScrollButtonsStatus(listRef, children);

  return (
    <Fragment>
      <Container {...props} ref={listRef}>{children}</Container>
      <RenderOnTablet>
        <ScrollButtons handleButtonClick={scroll}  leftEnabled={leftEnabled} rightEnabled={rightEnabled}/>
      </RenderOnTablet>
    </Fragment>
  );
};

const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
  height: ${themeResponsiveProperty('12rem', '18rem')};
  overflow-x: auto;
  transform: translateZ(0); // https://stackoverflow.com/a/30533339
  -webkit-overflow-scrolling: touch;
`;
